import * as yup from 'yup';

export const formSchema = yup.object({
    namePL: yup.string().required(),
    nameGB: yup.string().required(),
    nameUA: yup.string().required(),
    nameCZ: yup.string().required(),
    studentPrice: yup.number().required(),
    trainerPrice: yup.number().required(),
});
